import { render, staticRenderFns } from "./ComplianceIndex.vue?vue&type=template&id=c6864e38&scoped=true&"
import script from "./ComplianceIndex.vue?vue&type=script&lang=js&"
export * from "./ComplianceIndex.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=c6864e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6864e38",
  null
  
)

export default component.exports